import theme from 'config/theme';

export const styles = {
  wrapper: {
    display: 'flex',
    width: '700px',
    height: '750px',
    maxHeight: '100%',
    overflow: 'scroll',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: '8px 8px 0 0',
    background: '#FFFFFF',
    boxShadow: '0 0 10px 0 rgba(59, 130, 246, 0.20)',
    zIndex: 9,
    position: 'absolute',
    right: 40,
    bottom: 0,
  },
  minimizedWrapper: {
    width: '440px',
    zIndex: 9,
    position: 'absolute',
    right: 40,
    bottom: 0,
    boxShadow: '0 0 10px 0 rgba(59, 130, 246, 0.20)',
  },
  header: {
    display: 'flex',
    padding: '12px',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    background: theme.palette.blues.lightestBlue,
    color: theme.palette.grays.gray800,
  },
  headerButtons: {
    display: 'flex',
    gap: '8px',
  },
  headerButton: {
    color: theme.palette.grays.gray600,
    padding: '0',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.grays.gray600,
    },
    svg: {
      width: '14px',
    },
  },
  container: {
    padding: '20px',
    width: '100%',
  },
  subjectWrapper: {
    marginBottom: '12px',
  },
  containerInner: {
    marginBottom: '12px',
  },
  emailContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    alignSelf: 'stretch',
    flexGrow: 1,

    '& .compose-quill.quill-disabled .ql-container': {
      pointerEvents: 'none',
      opacity: 0.5,
    },

    '& .compose-quill.quill-disabled .ql-toolbar': {
      opacity: 0.5,
    },

    '& .compose-quill': {
      display: 'flex',
      flexDirection: 'column',
      height: '400px',
    },

    '& .compose-quill .ql-toolbar': {
      position: 'sticky',
      top: 0,
      zIndex: 10,
      background: 'white',
    },

    '& .compose-quill .ql-container': {
      flex: 1,
      overflowY: 'hidden',
      height: '150px',
    },
    '& .compose-quill .ql-insertTemplate': {
      position: 'relative',
      width: '75px!important',
      padding: '4px 6px!important',
      background: `${theme.palette.blues.primaryBlue500}!important`,
      borderRadius: '4px',
    },

    '& .compose-quill .ql-insertTemplate::after': {
      content: `'Templates'`,
      position: 'absolute',
      width: '100%',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: '#fff',
      fontSize: '11px',
      whiteSpace: 'nowrap',
    },
    '& .compose-quill .ql-toolbar.ql-snow': {
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      padding: '12px',
      border: `1px solid ${theme.palette.grays.gray300}`,
    },
    '& .compose-quill .ql-container.ql-snow ': {
      border: `1px solid ${theme.palette.grays.gray300}`,
      borderBottom: '0',
    },
    '& .compose-quill .ql-container .ql-editor ': {
      minHeight: '150px',
    },

    '& .compose-quill .ql-signatureAction:hover': {
      svg: {
        fill: '#06c',
      },
    },
  },

  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  signatureWrapper: {
    borderRadius: '8px',
    border: `1px solid ${theme.palette.grays.gray300}`,
    borderTop: 0,
    marginTop: '-20px',
    padding: '20px 15px 12px 15px',
    fontSize: '13px',
    lineHeight: 1.42,
    zIndex: 9999,
    position: 'relative',
    fontFamily: 'Helvetica, Arial, sans-serif',
    '& p': {
      margin: 0,
    },

    '& h1, & h2, & h3, & h4, & h5, & h6': {
      margin: 0,
      fontWeight: 600,
    },

    '& pre': {
      margin: 0,
      overflow: 'auto',
    },

    '& ol': {
      margin: 0,
      padding: 0,
    },
  },
};
